import Pagination from './Pagination';
export default Pagination;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/pagination/index.js
// module id = 208
// module chunks = 0